module.exports = __webpack_public_path__ + "img/Simple-Ramen.1df36ede.png";